export class Offset {
  constructor(public left: number, public top: number, public x: number, public y: number) {}
}
